import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../api';

const FF = 'Quicksand, Montserrat, Arial, sans-serif';

function ResultOverlay({ resultado, onClose }) {
  useEffect(() => {
    if (!resultado) return;
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [resultado, onClose]);

  if (!resultado) return null;
  const ok = resultado.tipo === 'exito';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(10,10,30,0.65)',
        backdropFilter: 'blur(10px)',
        cursor: 'pointer',
        fontFamily: FF
      }}
    >
      <style>{`
        @keyframes auOverlayIn { from { opacity:0; } to { opacity:1; } }
        @keyframes auCardIn { from { opacity:0; transform:scale(0.88); } to { opacity:1; transform:scale(1); } }
        @keyframes auCheck { from { stroke-dashoffset: 60; } to { stroke-dashoffset: 0; } }
        @keyframes auRing { from { transform:scale(0.6); opacity:0.8; } to { transform:scale(1.6); opacity:0; } }
        @keyframes auShake { 0%,100%{transform:translateX(0)} 20%{transform:translateX(-8px)} 40%{transform:translateX(8px)} 60%{transform:translateX(-5px)} 80%{transform:translateX(5px)} }
        @keyframes auCountdown { from { width:100%; } to { width:0%; } }
      `}</style>
      <div
        onClick={e => e.stopPropagation()}
        style={{
          position: 'relative',
          background: ok
            ? 'linear-gradient(135deg,#064e3b 0%,#065f46 50%,#047857 100%)'
            : 'linear-gradient(135deg,#7f1d1d 0%,#991b1b 50%,#b91c1c 100%)',
          borderRadius: 28, padding: '44px 40px 36px',
          textAlign: 'center', minWidth: 280, maxWidth: 360, width: '90vw',
          boxShadow: ok
            ? '0 0 60px rgba(16,185,129,0.4)'
            : '0 0 60px rgba(239,68,68,0.4)',
          animation: 'auCardIn 0.4s cubic-bezier(.34,1.56,.64,1)',
          overflow: 'hidden'
        }}
      >
        {/* Icono */}
        {ok ? (
          <div style={{ position: 'relative', width: 80, height: 80, margin: '0 auto 20px' }}>
            {[1,2,3].map(i => (
              <div key={i} style={{
                position: 'absolute', inset: 0, borderRadius: '50%',
                border: '2px solid rgba(16,185,129,0.5)',
                animation: `auRing 1.5s ease-out ${i * 0.3}s infinite`
              }} />
            ))}
            <div style={{
              position: 'absolute', inset: 0, borderRadius: '50%',
              background: 'rgba(16,185,129,0.2)', display: 'flex',
              alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                <path d="M8 22 L18 32 L36 14" stroke="#6ee7b7" strokeWidth="4"
                  strokeLinecap="round" strokeLinejoin="round"
                  strokeDasharray="60" strokeDashoffset="60"
                  style={{ animation: 'auCheck 0.5s 0.2s ease-out forwards' }} />
              </svg>
            </div>
          </div>
        ) : (
          <div style={{
            width: 72, height: 72, borderRadius: '50%', margin: '0 auto 20px',
            background: 'rgba(239,68,68,0.2)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            animation: 'auShake 0.5s 0.1s ease-out'
          }}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M10 10 L30 30 M30 10 L10 30" stroke="#fca5a5" strokeWidth="4"
                strokeLinecap="round" />
            </svg>
          </div>
        )}
        <div style={{ color: ok ? '#6ee7b7' : '#fca5a5', fontWeight: 800, fontSize: '1.35em', marginBottom: 8 }}>
          {ok ? '¡Usuario creado!' : 'Error'}
        </div>
        <div style={{ color: ok ? '#a7f3d0' : '#fecaca', fontSize: '1em', marginBottom: 24, lineHeight: 1.5 }}>
          {resultado.detalle}
        </div>
        {/* Barra countdown */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 4, background: 'rgba(255,255,255,0.1)' }}>
          <div style={{
            height: '100%',
            background: ok ? '#6ee7b7' : '#fca5a5',
            animation: 'auCountdown 3.5s linear forwards'
          }} />
        </div>
      </div>
    </div>
  );
}

function AdminUsuarios({ token }) {
  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('employee');
  const [allowModify, setAllowModify] = useState(false);
  const [usuarios, setUsuarios] = useState([]);

  // Modal crear
  const [showCrear, setShowCrear] = useState(false);
  const [creando, setCreando] = useState(false);
  const [resultadoCrear, setResultadoCrear] = useState(null);

  // Modal contraseña
  const [showPassword, setShowPassword] = useState(false);
  const [idModificar, setIdModificar] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [cambiandoPass, setCambiandoPass] = useState(false);
  const [resultadoPass, setResultadoPass] = useState(null);

  const fetchUsuarios = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/admin/usuarios`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsuarios(res.data);
    } catch { setUsuarios([]); }
  };

  useEffect(() => { fetchUsuarios(); }, [token]);

  const crearUsuario = async (e) => {
    e.preventDefault();
    setCreando(true);
    try {
      const res = await axios.post(
        `${API_BASE}/api/admin/usuario`,
        { nombre, apellidos, email, password, role, allowModify },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setResultadoCrear({ tipo: 'exito', detalle: res.data.message || 'Usuario creado correctamente.' });
      setNombre(''); setApellidos(''); setEmail(''); setPassword('');
      setRole('employee'); setAllowModify(false);
      setShowCrear(false);
      fetchUsuarios();
    } catch (err) {
      setResultadoCrear({
        tipo: 'error',
        detalle: err.response?.data?.error || 'Error al crear el usuario.'
      });
    } finally {
      setCreando(false);
    }
  };

  const modificarPassword = async (e) => {
    e.preventDefault();
    setCambiandoPass(true);
    try {
      await axios.put(
        `${API_BASE}/api/admin/usuario/${idModificar}/password`,
        { password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setResultadoPass({ tipo: 'exito', detalle: 'Contraseña modificada correctamente.' });
      setNewPassword(''); setIdModificar('');
      setShowPassword(false);
    } catch {
      setResultadoPass({ tipo: 'error', detalle: 'Error al modificar la contraseña.' });
    } finally {
      setCambiandoPass(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '0.75em 1em', borderRadius: 10,
    border: '2px solid #90caf9', fontFamily: FF, fontSize: '1rem',
    outline: 'none', boxSizing: 'border-box', color: '#1e293b',
    background: '#fff', transition: 'border-color 0.2s'
  };

  return (
    <div style={{ fontFamily: FF }}>
      <style>{`
        @keyframes auSpinRing { to { transform: rotate(360deg); } }
      `}</style>

      {/* Overlays de resultado */}
      <ResultOverlay resultado={resultadoCrear} onClose={() => setResultadoCrear(null)} />
      <ResultOverlay resultado={resultadoPass} onClose={() => setResultadoPass(null)} />

      {/* Botones de acción */}
      <div style={{ display: 'flex', gap: '1em', flexWrap: 'wrap', marginBottom: '1.5em' }}>
        <button
          onClick={() => setShowCrear(true)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5em',
            padding: '0.75em 1.6em', borderRadius: 12,
            border: '3px solid transparent',
            background: 'linear-gradient(white,white) padding-box, linear-gradient(135deg,#388e3c 0%,#66bb6a 100%) border-box',
            color: '#388e3c', fontWeight: 800, fontFamily: FF, fontSize: '1.02rem',
            cursor: 'pointer', boxShadow: '0 4px 12px rgba(56,142,60,0.18)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(56,142,60,0.28)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 4px 12px rgba(56,142,60,0.18)'; }}
        >
          ➕ Crear usuario
        </button>
        <button
          onClick={() => setShowPassword(true)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5em',
            padding: '0.75em 1.6em', borderRadius: 12,
            border: '3px solid transparent',
            background: 'linear-gradient(white,white) padding-box, linear-gradient(135deg,#f57c00 0%,#ffb74d 100%) border-box',
            color: '#f57c00', fontWeight: 800, fontFamily: FF, fontSize: '1.02rem',
            cursor: 'pointer', boxShadow: '0 4px 12px rgba(245,124,0,0.18)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(245,124,0,0.28)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 4px 12px rgba(245,124,0,0.18)'; }}
        >
          🔑 Cambiar contraseña
        </button>
      </div>

      {/* Lista de usuarios */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8em' }}>
        {usuarios.map(u => (
          <div key={u._id} style={{
            display: 'flex', alignItems: 'center', gap: '1em', flexWrap: 'wrap',
            padding: '0.9em 1.2em', borderRadius: 14,
            background: 'linear-gradient(135deg,rgba(25,118,210,0.04) 0%,rgba(66,165,245,0.07) 100%)',
            border: '2px solid rgba(25,118,210,0.12)',
            boxShadow: '0 2px 8px rgba(25,118,210,0.06)'
          }}>
            <span style={{ fontSize: 26 }}>{u.role === 'admin' ? '🛡️' : '👤'}</span>
            <div style={{ flex: 1, minWidth: 150 }}>
              <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '1em' }}>{u.nombre} {u.apellidos}</div>
              <div style={{ color: '#64748b', fontSize: '0.88em' }}>{u.email}</div>
            </div>
            <span style={{
              padding: '0.25em 0.8em', borderRadius: 20, fontSize: '0.82em', fontWeight: 700,
              background: u.role === 'admin' ? 'rgba(25,118,210,0.12)' : 'rgba(56,142,60,0.12)',
              color: u.role === 'admin' ? '#1976d2' : '#388e3c'
            }}>{u.role === 'admin' ? 'Admin' : 'Empleado'}</span>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.4em', fontSize: '0.88em', color: '#475569', cursor: 'pointer', userSelect: 'none' }}>
              <input
                type="checkbox"
                checked={!!u.allowModify}
                onChange={async e => {
                  try {
                    await axios.put(
                      `${API_BASE}/api/admin/usuario/${u._id}/allow-modify`,
                      { allowModify: e.target.checked },
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                    setUsuarios(us => us.map(x => x._id === u._id ? { ...x, allowModify: e.target.checked } : x));
                  } catch { /* silencioso */ }
                }}
                style={{ width: 15, height: 15, cursor: 'pointer' }}
              />
              Puede modificar fichajes
            </label>
          </div>
        ))}
        {usuarios.length === 0 && (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: '2em', fontSize: '1.05em' }}>
            No hay usuarios registrados.
          </div>
        )}
      </div>

      {/* Modal Crear usuario */}
      {showCrear && (
        <div
          onClick={() => !creando && setShowCrear(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 3000,
            background: 'rgba(10,20,40,0.55)', backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: 24,
              boxShadow: '0 24px 64px rgba(25,118,210,0.22)',
              padding: '2em 2.2em', width: 'min(92vw,440px)',
              fontFamily: FF, display: 'flex', flexDirection: 'column', gap: '1.2em'
            }}
          >
            {creando ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.2em', padding: '1.5em 0' }}>
                <div style={{
                  width: 56, height: 56,
                  border: '5px solid #e3f2fd', borderTop: '5px solid #388e3c',
                  borderRadius: '50%', animation: 'auSpinRing 0.8s linear infinite'
                }} />
                <div style={{ fontWeight: 700, fontSize: '1.1em', color: '#388e3c' }}>Creando usuario...</div>
              </div>
            ) : (
              <>
                <div style={{ fontWeight: 800, fontSize: '1.25em', color: '#1976d2', textAlign: 'center' }}>➕ Nuevo usuario</div>
                <form onSubmit={crearUsuario} style={{ display: 'flex', flexDirection: 'column', gap: '0.85em' }}>
                  <input style={inputStyle} placeholder="Nombre *" value={nombre} required
                    onChange={e => setNombre(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#1976d2'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'} />
                  <input style={inputStyle} placeholder="Apellidos *" value={apellidos} required
                    onChange={e => setApellidos(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#1976d2'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'} />
                  <input style={inputStyle} type="email" placeholder="Email *" value={email} required
                    onChange={e => setEmail(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#1976d2'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'} />
                  <input style={inputStyle} type="password" placeholder="Contraseña *" value={password} required
                    onChange={e => setPassword(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#1976d2'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'} />
                  <select style={inputStyle} value={role} onChange={e => setRole(e.target.value)}>
                    <option value="employee">Empleado</option>
                    <option value="admin">Administrador</option>
                  </select>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.6em', fontWeight: 600, color: '#475569', cursor: 'pointer', fontSize: '0.97em' }}>
                    <input type="checkbox" checked={allowModify} onChange={e => setAllowModify(e.target.checked)}
                      style={{ width: 16, height: 16, cursor: 'pointer' }} />
                    Permitir modificar fichajes
                  </label>
                  <div style={{ display: 'flex', gap: '0.8em', justifyContent: 'flex-end', marginTop: '0.4em' }}>
                    <button type="button" onClick={() => setShowCrear(false)}
                      style={{
                        padding: '0.65em 1.4em', borderRadius: 10,
                        border: '2px solid #cbd5e1', background: '#f8fafc',
                        color: '#64748b', fontWeight: 700, fontFamily: FF, fontSize: '1rem', cursor: 'pointer'
                      }}
                    >Cancelar</button>
                    <button type="submit"
                      style={{
                        padding: '0.65em 1.8em', borderRadius: 10,
                        border: '3px solid transparent',
                        background: 'linear-gradient(white,white) padding-box, linear-gradient(135deg,#388e3c 0%,#66bb6a 100%) border-box',
                        color: '#388e3c', fontWeight: 800, fontFamily: FF, fontSize: '1rem',
                        cursor: 'pointer', boxShadow: '0 4px 12px rgba(56,142,60,0.15)'
                      }}
                    >Crear usuario</button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {/* Modal Cambiar contraseña */}
      {showPassword && (
        <div
          onClick={() => !cambiandoPass && setShowPassword(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 3000,
            background: 'rgba(10,20,40,0.55)', backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: 24,
              boxShadow: '0 24px 64px rgba(245,124,0,0.18)',
              padding: '2em 2.2em', width: 'min(92vw,400px)',
              fontFamily: FF, display: 'flex', flexDirection: 'column', gap: '1.2em'
            }}
          >
            {cambiandoPass ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.2em', padding: '1.5em 0' }}>
                <div style={{
                  width: 56, height: 56,
                  border: '5px solid #fff3e0', borderTop: '5px solid #f57c00',
                  borderRadius: '50%', animation: 'auSpinRing 0.8s linear infinite'
                }} />
                <div style={{ fontWeight: 700, fontSize: '1.1em', color: '#f57c00' }}>Cambiando contraseña...</div>
              </div>
            ) : (
              <>
                <div style={{ fontWeight: 800, fontSize: '1.25em', color: '#f57c00', textAlign: 'center' }}>🔑 Cambiar contraseña</div>
                <form onSubmit={modificarPassword} style={{ display: 'flex', flexDirection: 'column', gap: '0.85em' }}>
                  <select style={inputStyle} value={idModificar} required onChange={e => setIdModificar(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#f57c00'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'}>
                    <option value="">Selecciona usuario *</option>
                    {usuarios.map(u => (
                      <option key={u._id} value={u._id}>{u.nombre} {u.apellidos} ({u.email})</option>
                    ))}
                  </select>
                  <input style={inputStyle} type="password" placeholder="Nueva contraseña *" value={newPassword} required
                    onChange={e => setNewPassword(e.target.value)}
                    onFocus={e => e.target.style.borderColor = '#f57c00'}
                    onBlur={e => e.target.style.borderColor = '#90caf9'} />
                  <div style={{ display: 'flex', gap: '0.8em', justifyContent: 'flex-end', marginTop: '0.4em' }}>
                    <button type="button" onClick={() => setShowPassword(false)}
                      style={{
                        padding: '0.65em 1.4em', borderRadius: 10,
                        border: '2px solid #cbd5e1', background: '#f8fafc',
                        color: '#64748b', fontWeight: 700, fontFamily: FF, fontSize: '1rem', cursor: 'pointer'
                      }}
                    >Cancelar</button>
                    <button type="submit"
                      style={{
                        padding: '0.65em 1.8em', borderRadius: 10,
                        border: '3px solid transparent',
                        background: 'linear-gradient(white,white) padding-box, linear-gradient(135deg,#f57c00 0%,#ffb74d 100%) border-box',
                        color: '#f57c00', fontWeight: 800, fontFamily: FF, fontSize: '1rem',
                        cursor: 'pointer', boxShadow: '0 4px 12px rgba(245,124,0,0.15)'
                      }}
                    >Guardar</button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminUsuarios;
